import { Card, Typography, Button, Container, Stack, TableContainer, TableHead, TableRow, TableCell, Checkbox, Table, TableBody, Popover, MenuItem, IconButton, Avatar, Dialog, DialogTitle, DialogContent, Grid, TextField, Autocomplete, FormControl, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import '../../Common_css/style.css';
import Iconify from 'src/components/iconify';
import whatsappIcon from 'src/components/icons/whatsapp (1).png';
import fb from '../../components/icons/fb.png';
import insta from '../../components/icons/instagram.png';
import website from '../../components/icons/global-network.png';
import twitter from '../../components/icons/twitter.png';
import uploadIcon from '../../components/images/profile-picture.png';
import { getData, patchFormData } from "src/webService/webService";
import { toast, ToastContainer } from "react-toastify";
import { id } from "date-fns/locale";


export default function Profile() {

    const getSessionValue = (key) => {
        const value = sessionStorage.getItem(key);
        return value != null || value != null || value != undefined ? value : '';
    };

    const profilePicture = getSessionValue('profile_picture');
    const SellerId = getSessionValue('Seller_UID');
    const profileName = getSessionValue('Name');
    const email = getSessionValue('Email');
    const phone = getSessionValue('phone');
    const userName = getSessionValue('UserName');
    const about = getSessionValue('aboutus');
    const phone_countrycode = getSessionValue('phone_countrycode');
    const whatsapp = getSessionValue('whatsapp');
    const whatsapp_countrycode = getSessionValue('whatsapp_countrycode');
    const facebook_link = getSessionValue('facebook_link');
    const instagram_link = getSessionValue('instagram_link');
    const twitter_link = getSessionValue('twitter_link');
    const website_link = getSessionValue('website_link');
    const Location = getSessionValue('location');
    const address = getSessionValue('address');
    const introVideo = getSessionValue('intro_video');
    const map_location = getSessionValue('map_location');
    const category = getSessionValue('category');
    const categories = getSessionValue('categories');
    const state = getSessionValue('state');
    const country = getSessionValue('country');
    const city = getSessionValue('city');
    const pincode = getSessionValue('pincode');
    const Token = getSessionValue('Token');

    const [openModal, setOpenModal] = useState(false);
    const [profileImage, setProfileImage] = useState(null);
    const [name, setName] = useState('');
    const [profileEmail, setProfileEmail] = useState('');
    const [profilePhone, setProfilePhone] = useState('');
    const [profileUserName, setProfileUserName] = useState('');
    const [profileAbout, setProfileAbout] = useState('');
    const [profilePhoneCountryCode, setProfilePhoneCountryCode] = useState('');
    const [profileWhatsApp, setProfileWhatsApp] = useState('');
    const [profileWhatsappCountryCode, setProfileWhatsappCountryCode] = useState('');
    const [profileFacebookLink, setProfileFacebookLink] = useState('');
    const [profileInstagramLink, setProfileInstagramLink] = useState('');
    const [profileTwitterLink, setProfileTwitterLink] = useState('');
    const [profileWebsiteLink, setProfileWebsiteLink] = useState('');
    const [profileLocation, setProfileLocation] = useState('');
    const [profileAddress, setProfileAddress] = useState('');
    const [profileIntroVideo, setProfileIntroVideo] = useState('');
    const [profileMapLocation, setProfileMapLocation] = useState('');
    const [profileCity, setProfileCity] = useState('');
    const [profileState, setProfileState] = useState('');
    const [profileCountry, setProfileCountry] = useState('');
    const [profilePincode, setProfilePincode] = useState('');
    const [previewVideo, setPreviewVideo] = useState(null);
    const [profileCategories, setProfileCategories] = useState([]);
    const [categoriesArray, setCategoriesArray] = useState([]);
    const [showPasswordField, setShowPasswordField] = useState(false);
    const [password, setPassword] = useState('');

    const handleOpenModal = () => {
        getCategoryData();
        setOpenModal(true);
    }

    const handleClose = () => {
        setOpenModal(false);
    }

    const initialImage = uploadIcon;
    const [preview, setPreview] = useState(initialImage);

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setPreview(URL.createObjectURL(file));
            setProfileImage(file)
        }
    };

    const handleVideoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const videoURL = URL.createObjectURL(file);
            setPreviewVideo(videoURL);
            setProfileIntroVideo(file);
        }
    };

    useEffect(() => {
        debugger;
        setName(profileName || '');
        setProfileEmail(email || '');
        setProfilePhone(phone || '');
        setProfileUserName(userName || '');
        setProfileAbout(about || '');
        setProfilePhoneCountryCode(phone_countrycode || '');
        setProfileWhatsApp(whatsapp || '');
        setProfileWhatsappCountryCode(whatsapp_countrycode || '');
        setProfileFacebookLink(facebook_link || '');
        setProfileInstagramLink(instagram_link || '');
        setProfileTwitterLink(twitter_link || '');
        setProfileWebsiteLink(website_link || '');
        setProfileLocation(Location || '');
        setProfileAddress(address || '');
        setPreviewVideo(introVideo || '');
        setProfileMapLocation(map_location || '');
        setPreview(profilePicture || initialImage);
        setProfileCity(city || '');
        setProfileCountry(country || '');
        setProfileState(state || '');
        setProfilePincode(pincode || '');
        setProfileCategories(category || '');
    }, []);

    const getCategoryData = async () => {
        const params = {
            // page: 1,
            // per_page: 20,
            all: 1,
            withChildren: 1
        }
        try {
            const res = await getData('categories', params, Token);
            if (res.status === 200) {
                console.log(res.data, "res.data");
                setCategoriesArray(res.data);
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }

    const handleCategoryChange = (event, newValue) => {
        const selectedIds = newValue.map((item) => item._id);
        setProfileCategories(selectedIds);
    };

    const updateProfile = () => {
        debugger;
        const formData = new FormData();

        if (profileImage === null) {

        } else {
            formData.append("profile_picture", profileImage);
        }

        if (profileIntroVideo === '') {

        } else {
            formData.append("intro_video", profileIntroVideo);
        }
        formData.append('name', name);
        formData.append('aboutus', profileAbout);
        formData.append('instagram_link', profileInstagramLink);
        formData.append('whatsapp', profileWebsiteLink);
        formData.append('address', profileAddress);
        formData.append('map_location', profileMapLocation);
        formData.append('facebook_link', profileFacebookLink);
        formData.append('twitter_link', profileTwitterLink);
        formData.append('website_link', profileWebsiteLink);
        formData.append('city', profileCity);
        formData.append('state', profileState);
        formData.append('country', profileCountry);
        formData.append('pincode', profilePincode);
        formData.append('phone_countrycode', profilePhoneCountryCode);
        formData.append('phone', profilePhone);
        formData.append('whatsapp_countrycode', profileWhatsappCountryCode);
        formData.append('whatsapp', profileWhatsApp);
        formData.append('category', JSON.stringify(profileCategories));

        if (showPasswordField === true) {
            if (password.length >= 8) {
                formData.append('password', password)
            } else {
                toast.error('password must be 8 characters')
                return;
            }
        }


        patchFormData(`seller/profile`, formData, Token)
            .then((res) => {

                const setSessionItem = (key, value) => {
                    sessionStorage.setItem(key, value == undefined || value == null || value == 'null' ? '' : value);
                };

                setSessionItem('profile_picture', res?.profile_picture);
                setSessionItem('Name', res?.name);
                setSessionItem('Email', res?.email);
                setSessionItem('phone', res?.phone);
                setSessionItem('UserName', res?.username);
                setSessionItem('aboutus', res?.aboutus);
                setSessionItem('phone_countrycode', res?.phone_countrycode);
                setSessionItem('whatsapp', res?.whatsapp);
                setSessionItem('whatsapp_countrycode', res?.whatsapp_countrycode);
                setSessionItem('facebook_link', res?.facebook_link);
                setSessionItem('instagram_link', res?.instagram_link);
                setSessionItem('twitter_link', res?.twitter_link);
                setSessionItem('website_link', res?.website_link);
                setSessionItem('location', res?.location);
                setSessionItem('address', res?.address);
                setSessionItem('intro_video', res?.intro_video);
                setSessionItem('map_location', res?.map_location);
                setSessionItem('category', res?.category);
                setSessionItem('categories', res?.category_names)
                setSessionItem('city', res?.city);
                setSessionItem('state', res?.state);
                setSessionItem('country', res?.country);
                setSessionItem('pincode', res?.pincode);
                handleClose();
                toast.success('Profile updated successfully');
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    return (
        <>
            <ToastContainer position="top-right" />

            <Helmet>
                <title> Profile</title>
            </Helmet>

            <div className='p-0 ProfilePage'>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                    <Typography variant="h4" className='title-color' gutterBottom>
                        Profile
                    </Typography>
                    <Button variant="contained" className='Button' onClick={handleOpenModal} startIcon={<Iconify icon="eva:edit-fill" />}>
                        Edit Profile
                    </Button>
                </Stack>

                {/* <Card className='card-bg p-4'> */}
                <div className="row">
                    <div className="col-lg-4">
                        <div className="card-bg p-4 profileCard">
                            <img className="profileImg" src={(profilePicture) ? profilePicture : '/assets/default-image.webp'} width='100%' />
                            <h3 className="text-center mt-3 mb-0">{profileName}</h3>
                            <p className="text-center mb-0">{userName}</p>
                            <p className="text-center mb-0">{categories}</p>
                            <p className="text-center mb-0">{SellerId}</p>
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="profileCard h-220px">
                                    <h5>About Us</h5><hr className="my-2" />
                                    {about ? <p className="fs-14">{about}</p> : <center className="fs-14 mt-2 py-4">Not updated</center>}
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="profileCard h-220px">
                                    <h5>Contact Information</h5><hr className="my-2" />
                                    <p className="fs-14 mb-2"><Iconify style={{ marginRight: '12px' }} icon={"eva:email-outline"} /> {email}</p>
                                    <p className="fs-14 mb-2"><Iconify style={{ marginRight: '12px' }} icon={"eva:phone-outline"} />{phone_countrycode} {phone}</p>
                                    <p className="fs-14 d-flex align-items-center"><img style={{ marginRight: '12px', width: '6%' }} src={whatsappIcon} />{whatsapp_countrycode} {whatsapp}</p>
                                    <hr className="my-2" />
                                    <div className="profile-social-links d-flex justify-content-center align-items-center mt-3">
                                        <a
                                            target="_blank"
                                            className={`d-flex justify-content-center align-items-center ${(facebook_link) ? '' : 'disabled'}`}
                                            title={(facebook_link) ? '' : 'Link not provided'}
                                            href={(facebook_link) ? facebook_link : 'javascript:void(0)'}>
                                            <img src={fb} width='40%' />
                                        </a>
                                        <a
                                            target="_blank"
                                            className={`d-flex justify-content-center align-items-center ${(twitter_link) ? '' : 'disabled'}`}
                                            title={(twitter_link) ? '' : 'Link not provided'}
                                            href={(twitter_link) ? twitter_link : 'javascript:void(0)'}>
                                            <img src={twitter} width='40%' />
                                        </a>
                                        <a
                                            target="_blank"
                                            className={`d-flex justify-content-center align-items-center ${(instagram_link) ? '' : 'disabled'}`}
                                            title={(instagram_link) ? '' : 'Link not provided'}
                                            href={(instagram_link) ? instagram_link : 'javascript:void(0)'}>
                                            <img src={insta} width='40%' />
                                        </a>
                                        <a
                                            target="_blank"
                                            className={`d-flex justify-content-center align-items-center ${(website_link) ? '' : 'disabled'}`}
                                            title={(website_link) ? '' : 'Link not provided'}
                                            href={(website_link) ? website_link : 'javascript:void(0)'}>
                                            <img src={website} width='40%' />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-lg-12">
                                <div className="profileCard h-220px">
                                    <h5>Location Details</h5><hr className="my-2" />
                                    <p className="fs-14 mb-2"><Iconify style={{ marginRight: '12px' }} icon={"eva:pin-outline"} />{address === 'null' ? '' : address} {Location}, {pincode}</p>
                                    {/* <iframe
                                        title="Google Map"
                                        src={map_location}
                                        width="100%"
                                        height="40%"
                                        style={{ border: 0 }}
                                        allowFullScreen=""
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                        className="mt-3"
                                    ></iframe> */}
                                    {(map_location) ? <a href={map_location} target="_blank"><Button style={{ marginTop: '20px' }} variant="contained" className='Button'>Click to view map location</Button></a> : <center className="fs-14 mt-2 py-4 border rounded">Map link not provided</center>}
                                </div>
                            </div>
                            {/* <div className="col-lg-6">
                                <div className="profileCard h-220px">
                                    <h5>Intro Video</h5><hr className="my-2" />
                                    {(introVideo) ?
                                        <video width="100%" height="130px" controls>
                                            <source
                                                src={introVideo}
                                            // type="video/mp4"
                                            />
                                        </video>
                                        : <center className="fs-14 mt-2 py-5">Intro video not uploaded</center>}
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
                {/* </Card> */}
            </div>
            <Dialog open={openModal} onClose={handleClose} maxWidth="md" fullWidth>
                <div className="d-flex justify-content-between">
                    <DialogTitle>Edit Profile</DialogTitle>
                    <Iconify icon='material-symbols:close-rounded' sx={{ margin: '12px',cursor:'pointer'}} onClick={handleClose} />
                </div>
                <DialogContent>
                    <Grid container spacing={1}>
                        <Grid item xs={12} className='mt-3' justifyContent="center">
                            <Grid item xs={6} alignItems="center" sx={{ margin: "0 auto" }}>
                                <div style={{ textAlign: "center", padding: '12px', border: '1px solid #e3e3e3', borderRadius: '10px' }}>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        id="fileInput"
                                        style={{ display: "none" }}
                                        onChange={handleImageChange}
                                    />
                                    <label htmlFor="fileInput">
                                        <img
                                            src={preview || initialImage}
                                            alt="Uploaded"
                                            style={{
                                                width: "300px",
                                                height: "230px",
                                                objectFit: "contain",
                                                cursor: "pointer",
                                                borderRadius: "10px",
                                            }}
                                        />
                                        <p className='mb-0' style={{ fontSize: '12px' }}>Edit image</p>
                                    </label>
                                </div>
                            </Grid>
                        </Grid>
                        {/* <Grid item xs={6} className='mt-3'>
                            <div style={{ textAlign: "center", padding: '12px', border: '1px solid #e3e3e3', borderRadius: '10px' }}>
                                <input
                                    type="file"
                                    accept="video/*"
                                    id="videoInput"
                                    style={{ display: "none" }}
                                    onChange={handleVideoChange}
                                />
                                <label htmlFor="videoInput">
                                    {previewVideo ? (
                                        <video
                                            src={previewVideo}
                                            controls
                                            style={{
                                                width: "300px",
                                                height: "220px",
                                                objectFit: "contain",
                                                cursor: "pointer",
                                                borderRadius: "10px",
                                            }}
                                        />
                                    ) : (
                                        <div style={{
                                            width: "300px",
                                            height: "230px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            backgroundColor: "#f0f0f0",
                                            borderRadius: "10px",
                                            cursor: "pointer"
                                        }}>
                                            <p style={{ fontSize: '14px', color: '#666' }}>Click to upload video</p>
                                        </div>
                                    )}
                                    <p className='mb-0' style={{ fontSize: '12px' }}>Edit video</p>
                                </label>
                            </div>
                        </Grid> */}
                        {/* <Grid item xs={12} className='mt-3'>
                            <Autocomplete
                                multiple
                                options={(categoriesArray || []).filter((cat) => cat.subCategoryCount === 0)}
                                groupBy={(option) => {
                                    const parent = categoriesArray.find(
                                        (parentCat) => parentCat._id == option.parent
                                    );
                                    return parent?.name || 'Uncategoriezed';
                                }}
                                getOptionLabel={(option) => ((option.parent != null) ? "" : "") + `${option.name}`}
                                value={categoriesArray.filter((item) => profileCategories.includes(item._id))}
                                onChange={handleCategoryChange}
                                renderInput={(params) => (
                                    <TextField {...params} label="Category" variant="outlined" />
                                )}
                                renderGroup={(params) => (
                                    <div key={params.key}>
                                        <Typography sx={{ mt: 0, mb: 0, fontWeight: 'bold', px: 2, background: '#dbdee2' }}>
                                            {params.group}
                                        </Typography>
                                        {params.children}
                                    </div>
                                )}
                            />

                        </Grid> */}
                        <Grid item xs={6} className='mt-3'>
                            <TextField
                                className="w-100"
                                id="outlined-basic"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                label="Name *"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                disabled
                            />
                        </Grid>
                        {/* <Grid item xs={6} className='mt-3'>
                            <TextField
                                className="w-100"
                                id="outlined-basic"
                                value={profileEmail}
                                onChange={(e) => setProfileEmail(e.target.value)}
                                label="Email *"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid> */}
                        {/* <Grid item xs={6} className='mt-3'>
                            <TextField
                                className="w-100"
                                id="outlined-basic"
                                value={profileUserName}
                                onChange={(e) => setProfileUserName(e.target.value)}
                                label="User Name *"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid> */}
                        <Grid item xs={2} className='mt-3'>
                            <TextField
                                className="w-100"
                                id="outlined-basic"
                                value={profilePhoneCountryCode}
                                onChange={(e) => setProfilePhoneCountryCode(e.target.value)}
                                label="Country Code *"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={4} className='mt-3'>
                            <TextField
                                className="w-100"
                                id="outlined-basic"
                                value={profilePhone}
                                onChange={(e) => setProfilePhone(e.target.value)}
                                label="Mobile Number *"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={2} className='mt-3'>
                            <TextField
                                className="w-100"
                                id="outlined-basic"
                                value={profileWhatsappCountryCode}
                                onChange={(e) => setProfileWhatsappCountryCode(e.target.value)}
                                label="Country Code *"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={4} className='mt-3'>
                            <TextField
                                className="w-100"
                                id="outlined-basic"
                                value={profileWhatsApp}
                                onChange={(e) => setProfileWhatsApp(e.target.value)}
                                label="Whatsapp Number *"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} className='mt-3'>
                            <TextField
                                className="w-100"
                                id="outlined-basic"
                                value={profileFacebookLink}
                                onChange={(e) => setProfileFacebookLink(e.target.value)}
                                label="Facebook Link"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} className='mt-3'>
                            <TextField
                                className="w-100"
                                id="outlined-basic"
                                value={profileInstagramLink}
                                onChange={(e) => setProfileInstagramLink(e.target.value)}
                                label="Instagram Link"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} className='mt-3'>
                            <TextField
                                className="w-100"
                                id="outlined-basic"
                                value={profileWebsiteLink}
                                onChange={(e) => setProfileWebsiteLink(e.target.value)}
                                label="Website Link"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} className='mt-3'>
                            <TextField
                                className="w-100"
                                id="outlined-basic"
                                value={profileTwitterLink}
                                onChange={(e) => setProfileTwitterLink(e.target.value)}
                                label="Twitter Link"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} className='mt-3'>
                            <TextField
                                className="w-100"
                                id="outlined-basic"
                                value={profileMapLocation}
                                onChange={(e) => setProfileMapLocation(e.target.value)}
                                label="Map Location"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} className='mt-3'>
                            <TextField
                                className="w-100"
                                id="outlined-basic"
                                value={profileAddress}
                                onChange={(e) => setProfileAddress(e.target.value)}
                                label="Address *"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                required
                            />
                        </Grid>
                        <Grid item xs={3} className='mt-3'>
                            <TextField
                                className="w-100"
                                id="outlined-basic"
                                value={profileCity}
                                onChange={(e) => setProfileCity(e.target.value)}
                                label="City *"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                required
                            />
                        </Grid>
                        <Grid item xs={3} className='mt-3'>
                            <TextField
                                className="w-100"
                                id="outlined-basic"
                                value={profileState}
                                onChange={(e) => setProfileState(e.target.value)}
                                label="State *"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                required
                            />
                        </Grid>
                        <Grid item xs={3} className='mt-3'>
                            <TextField
                                className="w-100"
                                id="outlined-basic"
                                value={profileCountry}
                                onChange={(e) => setProfileCountry(e.target.value)}
                                label="Country *"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={3} className='mt-3'>
                            <TextField
                                className="w-100"
                                id="outlined-basic"
                                value={profilePincode}
                                onChange={(e) => setProfilePincode(e.target.value)}
                                label="Pincode *"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} >
                            {!showPasswordField ? (
                                <Grid item xs={6} className="mt-3">
                                    <Typography
                                        variant="body1"
                                        style={{ cursor: 'pointer', color: '#1976d2', textDecoration: 'underline' }}
                                        onClick={() => setShowPasswordField(true)}
                                    >
                                        Change Password
                                    </Typography>
                                </Grid>
                            ) : (
                                <div className="d-flex align-items-center">
                                    <Grid item xs={12} className="mt-3">
                                        <TextField
                                            className="w-100"
                                            id="outlined-password"
                                            type="password"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            label="New Password *"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Grid>
                                    <Iconify icon="eva:close-outline" onClick={() => setShowPasswordField(false)} />
                                </div>
                            )}
                        </Grid>
                        <Grid item xs={12} className='mt-3'>
                            <TextField
                                className="w-100"
                                id="outlined-basic"
                                value={profileAbout}
                                onChange={(e) => setProfileAbout(e.target.value)}
                                label="About Us *"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                    </Grid>
                    <div className='mt-4 d-flex justify-content-end'>
                        <Button variant="contained" className='Button' onClick={updateProfile}>
                            Submit
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}

